import { Platform } from "react-native";

let messaging;

if (Platform.OS === "web") {
  // Web ke liye Firebase Messaging
  const { getMessaging } = require("firebase/messaging");
  const { initializeApp } = require("firebase/app");

  const firebaseConfig = {
    apiKey: "AIzaSyAXTP46UvfSOISjAYLVoBdHnMg8ZnW2o0o",
    authDomain: "nutrisearch-6b83a.firebaseapp.com",
    projectId: "nutrisearch-6b83a",
    storageBucket: "nutrisearch-6b83a.appspot.com",
    messagingSenderId: "1041058281114",
    appId: "1:1041058281114:web:b9a2cbade03f2fa4251123",
  };

  const app = initializeApp(firebaseConfig);
  messaging = getMessaging(app);
} else {
  // Native ke liye React Native Firebase Messaging
  messaging = require("@react-native-firebase/messaging").default;
}

export default messaging;
